import { CSSProperties } from "react";
import styles from "./ROISquare.module.scss";
import classNames from "classnames";

// Stroke and radius scale with the box so it keeps the same shape at every size
// (small card thumbnails, hover preview, full image view)
const STROKE_RATIO = 0.025;
const MIN_STROKE = 1.5;
const MAX_STROKE = 4;
const RADIUS_RATIO = 0.06;

export const roiCornerRadius = (size: number) => size * RADIUS_RATIO;

const clamp = (value: number, min: number, max: number) =>
  Math.min(max, Math.max(min, value));

// Drawn as corner handles only so the defect inside stays fully visible
export const ROISquare = ({ size }: { size: number }) => {
  const style = {
    width: size,
    height: size,
    "--roi-stroke": `${clamp(size * STROKE_RATIO, MIN_STROKE, MAX_STROKE)}px`,
    "--roi-radius": `${roiCornerRadius(size)}px`,
  } as CSSProperties;

  return (
    <div
      className={classNames(styles.square, { [styles.visible]: size > 0 })}
      style={style}
    >
      <span className={classNames(styles.corner, styles.topLeft)} />
      <span className={classNames(styles.corner, styles.topRight)} />
      <span className={classNames(styles.corner, styles.bottomLeft)} />
      <span className={classNames(styles.corner, styles.bottomRight)} />
    </div>
  );
};
